// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2715":"f4527d8e","3313":"a0dfd116","3726":"c76b8639","6073":"c76b8639","6892":"a28e4d36","7367":"6e99f84a","7524":"f4527d8e","8524":"3a395839"}[chunkId] + ".chunk.css";
};